import TabsRow from "./TabsRow";

import { getFieldValue, getItemId, getRouter, getSaveResult } from "~/stateGetter";

import identify from "~/identify";
import { replace } from 'redux-little-router';
import find from "lodash/find";

import type { WidgetNode, WidgetRowProps } from "./WidgetRow";
import { BigRadio } from "~/native-ui";

export function createTabRow (defaultProps: any = {}) {
    return ({
        Component: TabsRow,
        mapStateToProps: (state, { widgetName, modelId, nodes, referenceField, }, {value, ...widgetProps}) => {

            const isNewItem = getItemId(state, modelId) === identify.NEW_ITEM,
                stateprops = ({
                    ...widgetProps,
                    lastSavedAt: getSaveResult(state, modelId)?.finished_at ?? null,
                    selectedNode: (widgetName && findActiveNodeKey(nodes, getRouter(state).query[widgetName]))
                            ?? (referenceField && findActiveNodeKey( nodes, value, isNewItem ))
                            ?? null,
                    
                    variant: defaultProps.variant,
                })

            if (stateprops.variant === "wizard") {
                stateprops.variant = referenceField && getFieldValue(state, modelId, identify.EDITFIELD, referenceField)?.value !== "COMPLETED"
                    ? stateprops.variant
                    : "tabs";
            }

            return stateprops;
        },
        mapDispatchToProps: (dispatch, props) => ({
            onChange: (nextTab: string | number) => {
                const key = props.nodes.find((tab) => tab.key === nextTab).key;
                dispatch(replace({ path: "", query: { [props.widgetName]: key }}, { persistQuery: true, forceChangeRootModel: false }))
            },
        }),
        mergeProps: (stateprops, { onChange }, {nodes, widgetName, displayAs, ...props}) => {
            const { lastSavedAt, selectedNode } = stateprops;
            return {
                ...props,
                ...defaultProps,
                tabs: nodes,
                name: widgetName,
                variant: stateprops.variant,
                onChange: widgetName ? onChange : props.onChange,
                controlled: widgetName ? true : false,
                value: selectedNode ?? props.value,
                lastSavedAt: lastSavedAt,
                errorTabs: stateprops.errorNodes,
            }
        },
    })
}


export function createBigRadio (defaultProps = {}) {
    return ({
        Component: BigRadio,
        mergeProps: (stateprops, { onChange }, {widgetName, nodes, displayAs, ...props}: WidgetRowProps) => {
            return {
                ...props,
                ...defaultProps,
                selections: nodes.map((node) => ({
                    ...node,
                    ...(node.isWidgetGroup ? { nodes: node.nodes.map((subNode) => ({ ...subNode, value: subNode.value || subNode.key })) } : {}),
                    value: (node.isWidgetGroup === true ? node.key : node.value) || node.key,
                })),
                onChange,
                name: widgetName,
                value: stateprops.value,
                invalid: !!stateprops.errorNodes?.length,
            }
        },
    })
}


function findActiveNodeKey(nodes: WidgetNode[], foundActiveNode?: string | null, isNewItem?: boolean) {
    if (isNewItem) return null;
    if (!foundActiveNode) return null;
    if (foundActiveNode === "COMPLETED") return null;
    const foundNode = find(nodes, { key: foundActiveNode + "" });
    return !foundNode || foundNode?.disabled ? null : foundNode.key;
}
    